import { render, staticRenderFns } from "./CargoDetails.vue?vue&type=template&id=4f660cee"
import script from "./CargoDetails.vue?vue&type=script&lang=js"
export * from "./CargoDetails.vue?vue&type=script&lang=js"
import style0 from "./CargoDetails.vue?vue&type=style&index=0&id=4f660cee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports